import { type GQLModelFilter, type GQLVisualSelectorModelFragment } from "@src/graphql.generated";
import { type VisualSelectorGroupedModel } from "@src/pages/searchResult/components/VehicleCard";

export const resolveQueryFilter = (
    isFirstStep: boolean,
    brandId: string,
    categoryId: string | null,
    defaultRegionModelsOnly: boolean,
    defaultRegion: string,
) => {
    // empty categories are hidden server-side, so every card the selector renders leads somewhere
    let composedFilter: GQLModelFilter = { brand: { equal: brandId }, parent: { equal: categoryId }, hasVisibleDescendants: true };
    if (isFirstStep) {
        composedFilter = { ...composedFilter, isWpArticle: { equal: false } };
    }
    if (defaultRegionModelsOnly) {
        composedFilter = { ...composedFilter, specification: defaultRegion };
    }

    return composedFilter;
};

export const resolveColorOrderedModels = (models?: GQLVisualSelectorModelFragment[], isLastStep?: boolean): VisualSelectorGroupedModel[] => {
    let colorOrderedModels: VisualSelectorGroupedModel[] = [];
    if (isLastStep) {
        // group models by color
        colorOrderedModels =
            models?.reduce<VisualSelectorGroupedModel[]>((orderedModels, currentModel: GQLVisualSelectorModelFragment) => {
                if (currentModel.color) {
                    const colorGroupModel = orderedModels.find((item) => item.color === currentModel.color);
                    if (colorGroupModel) {
                        const modifiedOrderedModels = orderedModels.map((item) => {
                            if (item.color === currentModel.color) {
                                return {
                                    ...item,
                                    additionalColorGroupModels: item.additionalColorGroupModels
                                        ? item.additionalColorGroupModels.concat([currentModel])
                                        : [currentModel],
                                };
                            }

                            return item;
                        });

                        return modifiedOrderedModels;
                    } else {
                        orderedModels.push(currentModel);
                    }
                } else {
                    orderedModels.push(currentModel);
                }

                return orderedModels;
            }, []) ?? [];
    }

    return colorOrderedModels;
};
